import request from 'superagent';
import BriefStore from 'contest/stores/brief-store';
import propertyOrNull from 'contest/utils/property-or-null';

const pendingRequests = {};

export default function briefSaveElementAction(context, payload, done) {
    const store = context.getStore(BriefStore);
    const saveBriefElementUrl = store.saveBriefElementUrl;

    context.dispatch('BRIEF_SAVE_START', payload);

    var id = payload.section + ':' + payload.element;

    if (pendingRequests[id]) {
        pendingRequests[id].abort();
    }

    const value = store.outline[payload.section].elements[payload.element].value;

    pendingRequests[id] = request
        .post(saveBriefElementUrl)
        .timeout(10000)
        .type('form')
        .send({
            section: payload.section,
            element: payload.element,
            value: JSON.stringify(value),
        })
        .end(function(err, res) {
            if (err) {
                context.dispatch('BRIEF_SAVE_ERROR', payload);
            } else {
                let resource = JSON.parse(res.text);
                context.dispatch('BRIEF_SAVE_SUCCESS', {
                    ...payload,
                    score: propertyOrNull(resource, '_embedded', 'score'),
                });
            }

            done();
        });
}



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/brief-save-element.jsx